export const UPDATE_LIKE_AND_COMMENTS_MEMBERS = 'NURSERIES/UPDATE_LIKE_AND_COMMENTS_MEMBERS'
export const UPDATE_LIKE_AND_COMMENTS_MEMBERS_SUCCESS = 'NURSERIES/UPDATE_LIKE_AND_COMMENTS_MEMBERS_SUCCESS'
export const UPDATE_LIKE_AND_COMMENTS_MEMBERS_FAILED = 'NURSERIES/UPDATE_LIKE_AND_COMMENTS_MEMBERS_FAILED'
